import {
  MissionControlPaginatedDisputesQueryCgResponse,
  MissionControlPaginatedDisputesQueryVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';
import { DisputeListItemFragment } from '@pay-bill/graphql/fragments';

export const MISSION_CONTROL_PAGINATED_DISPUTES_QUERY: TypedDocumentNode<
  MissionControlPaginatedDisputesQueryCgResponse,
  MissionControlPaginatedDisputesQueryVariables
> = gql`
  query MissionControlPaginatedDisputes(
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection
    $orderField: DisputeOrderField
    $filters: PaginatedDisputesFilterInput
  ) {
    missionControlPaginatedDisputes(
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
      filters: $filters
    ) {
      totalCount
      disputes {
        id
        ...DisputeListItemFragment
      }
    }
  }

  ${DisputeListItemFragment}
`;
